import { EntityModel } from '@/interfaces'
import {
  ALL_BARGAIN_CONFIGS_QUERY,
  CREATE_BARGAIN_CONFIG_MUTATION,
  DELETE_BARGAIN_CONFIG_MUTATION,
  FORCE_DELETE_BARGAIN_CONFIG_MUTATION,
  SINGLE_BARGAIN_CONFIG_QUERY,
  UPDATE_BARGAIN_CONFIG_MUTATION,
} from './graphql'
import bargainTierEntity from '@/entities/bargainTier/entity'

const ratioBargainConfigModel: EntityModel = {
  name: 'bargainConfig',
  namePlural: 'bargainConfigs',
  uniqueName: 'ratioBargainConfig',
  uniqueNamePlural: 'ratioBargainConfigs',
  path: 'config/ratio/bargain/bargain_config',
  baseUrl: '/config/ratio/bargain/bargain_configs',
  translationPrefix: 'entities:ratioBargainConfig.',
  getDisplayName: (values: any) => {
    return 'RATIO BARGAIN CONFIG'
  },
  gql: {
    getAll: ALL_BARGAIN_CONFIGS_QUERY,
    getSingle: SINGLE_BARGAIN_CONFIG_QUERY,
    create: CREATE_BARGAIN_CONFIG_MUTATION,
    update: UPDATE_BARGAIN_CONFIG_MUTATION,
    delete: DELETE_BARGAIN_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_BARGAIN_CONFIG_MUTATION,
  },
  attributes: {
    active: {
      name: 'active',
      label: 'entities:ratioBargainConfig.attributes.active.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    tiers: {
      name: 'tiers',
      label: 'entities:ratioBargainConfig.attributes.tiers.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return bargainTierEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    priceCap: {
      name: 'priceCap',
      label: 'entities:ratioBargainConfig.attributes.priceCap.label',
      type: 'value',
      dataType: 'number',
      defaultInput: false,
      inputType: 'number',
      validationType: 'string',
      validations: [
        {
          type: 'number',
        },
      ],
    },
    serviceCodePrefix: {
      name: 'serviceCodePrefix',
      label: 'entities:ratioBargainConfig.attributes.serviceCodePrefix.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default ratioBargainConfigModel
